import React from 'react'
import '../Cardpage.css';
import baby2 from '../Images/baby2.jpg'
import baby3 from '../Images/baby3.jpg'
function BabyCare() {
  return (
    <>
    <div className='cardpagediv'>
      <h3 className='cardpagehead'>Baby Care</h3>
      <img src={baby2} className='w-100 imgbanner'  alt="" />
    </div>
    <p className='cardpagepara1 ms-2 me-2'>
      We give utmost care in baby products so we only provide and recomend the high quality products that are 100% safe for babies.

    </p>
    <h5 className='cardpagehead5'>
      Major Baby Items we have:
    </h5>
    <div>
    <ul>
      <li>Baby Milk powders</li>
      <li>Baby Diapers</li>
      <li>Baby Powder</li>
      <li>Baby Lotions and creams</li>
      <li>Baby Feeding Bottles</li>
      <li>Baby Suppliments </li>
      <li>Baby Syrups</li>
      <li>Baby Suppositories </li>
    </ul>
    </div>
    <p className='ms-2 pagebott'>We have all products for babies and Childern with maximum discounts. </p>
    </>
  )
}

export default BabyCare